import React from 'react';
import { Modal } from '@/components/ui';
import { Avatar } from '../components/Avatar';

export const AssignedUsersModal = ({
  isOpen,
  onClose,
  assignedTo
}) => {
  if (!Array.isArray(assignedTo)) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Assigned Employees (${assignedTo.length})`}
      size="sm"
    >
      <div className="flex flex-col gap-3 py-2 max-h-80 overflow-y-auto">
        {assignedTo.map(user => (
          <div key={user._id || user.id} className="flex items-center gap-3 p-2 hover:bg-gray-50 rounded-lg transition-colors border border-gray-100 shadow-sm">
            <Avatar name={`${user.firstName} ${user.lastName}`} size="md" />
            <div>
              <p className="text-sm font-semibold text-gray-800">{user.firstName} {user.lastName}</p>
              <p className="text-xs text-gray-500 capitalize">{user.role?.replace('_', ' ') || 'Employee'}</p>
            </div>
          </div>
        ))}
        {assignedTo.length === 0 && (
          <p className="text-sm text-gray-500 text-center py-4">No employees assigned to this conversation.</p>
        )}
      </div>
    </Modal>
  );
};
